import { r as n } from "./index656.mjs";
const i = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function c(e) {
  const t = `${e}`.match(i);
  return t && t[1] || "";
}
function f(e, t = "") {
  return e.displayName || e.name || c(e) || t;
}
function u(e, t, r) {
  const a = f(t);
  return e.displayName || (a !== "" ? `${r}(${a})` : r);
}
function d(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return f(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case n.ForwardRef:
          return u(e, e.render, "ForwardRef");
        case n.Memo:
          return u(e, e.type, "memo");
        default:
          return;
      }
  }
}
export {
  d as default,
  c as getFunctionName
};
